import { useContext } from "react";
import AuthContext from "./AuthContext";
import Login from "../../components/common/Login";
import Header from "../../components/common/Header";
import { useLocation, Navigate } from "react-router-dom";
import { ChatPanelProvider } from '../../components/common/Chat/ChatPanelContext';
import ChatPanel from '../../components/common/Chat/ChatPanel';
import { ShiftProvider } from "../../components/Pages/AppPAges/Lottery/ShiftContext";
import { detectAppFromPath } from "../../components/common/appRoutes"; 

const Auth = ({ check, children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const restrictedRoutes = [
    '/subscription-page',
    '/payment-page',
    '/subscription-modal'
  ];

  if (user?.user_id && restrictedRoutes.includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }

  const currentApp = detectAppFromPath(location.pathname);
  const isPosApp = currentApp === 'pos_app';

  if (check) {
    return user?.user_id ? (
      <ShiftProvider>
        <ChatPanelProvider>
          {/* Conditionally render Header (excluding on change-password route) */}
          {location.pathname !== '/change-password' && <Header />}

          {children}
          {/* Floating chat bubble removed - team chat is reached via the
              "Chat To Team" item in the profile menu instead. */}
          <ChatPanel />
        </ChatPanelProvider>
      </ShiftProvider>
    ) : (
      <Login />
    );
  }

  return children;
};

export default Auth;
